import { gql } from "@apollo/client";

const USER_LEAGUE_POINTS = gql`
  query userLeaguePoints($rankingId: Int!, $filter: ListTournamentRankingsEntryInput) {
    userLeaguePoints(rankingId: $rankingId, filter: $filter)
  }
`;

export default USER_LEAGUE_POINTS;
